<template>
	<v-container>
		<v-card class="shadowCard">
			<v-card-title primary-title>
			  <span class="text-caption">Activa tus notificaciones</span>
			</v-card-title>
			<v-card-text>
		  	<v-row>
		  		<v-col cols="12" class="pb-0">
				    <v-checkbox
				      v-model="descuentoPagos"
				      label="Aviso de pago"
				      hide-details
				    ></v-checkbox>
		  		</v-col>

		  		<v-col cols="12" class="pb-0">
				    <v-checkbox
				      v-model="inicioClases"
				      label="Inicio de clases"
				      hide-details
				    ></v-checkbox>
		  		</v-col>

					<v-col cols="12" class="pb-0">
				    <v-checkbox
				      v-model="examenes"
				      label="Días de exámenes"
				      hide-details
				    ></v-checkbox>
		  		</v-col>

					<v-col cols="12" class="pb-0">
				    <v-checkbox
				      v-model="palabraDiaria"
				      label="Palabra del día"
				      hide-details
				    ></v-checkbox>
		  		</v-col>
		  	</v-row>
			</v-card-text>

		  <v-card-actions class="mt-4">
		    <v-spacer></v-spacer>
		    <v-btn
		      color="primary"
		      class="text-capitalize px-6"
		      @click="listo()"
		      rounded
		    >
		      Guardar
		    </v-btn>
		  </v-card-actions>
		</v-card>

		<Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>

	</v-container>
</template>
<script>
	import { mapActions, mapGetters } from 'vuex'
	// Dependencias
  const md5     = require('md5')

  // Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

  // Mixins
  import  validarErrores from '@/mixins/validarErrores.js';

  export default {
  	components:{
  		Alerta,
  		Loader
  	},

  	mixins:[validarErrores],

  	props:[
			'perfil'
	  ],

    data: () => ({
    	descuentoPagos: false,
			inicioClases: false,
			examenes: false,
			palabraDiaria: false,
			
    	disabled: true,
    	
      respuestaAlerta: false,
      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},
    }),

    computed:{
    	...mapGetters( 'login', [ 'getUsuarioLMS', 'getDatosUsuarioLMS']),

    },

    methods: {
    	...mapActions( 'login', [ 'grabarUsuario', 'grabarDatosUsuario' ]),

    	habilitarVentana ( ventana ){
    		this.ventana = ventana
    	},

      validarUsuario (){
      	
      },
    },
  }
</script>
<style scoped>
	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.15)  !important;
	}

</style>